import React, { Component } from 'react';
import Helmet from "react-helmet";
// import { inject, observer } from 'mobx-react';
// import './style.scss';

import LineMenu from '../../components/liveMenu/';
import LineList from '../../components/line/';
import UnderHeader from "../../components/underHeader";
// import LoadingSpinner from '../../components/loadingSpinner/';

// @inject('lineStore')
// @observer
export default  class Line extends Component { 

	componentWillMount() {
		// this.props.lineStore.loadLine();
	}
	
	render() {
			return(
				<div className="stats-index">
					<div className="blue_line">
						<UnderHeader type={2} />
					</div>
					<Helmet>
						<title>ИРМ - Статистика</title>
					</Helmet>
					<h1>Статистика</h1>
					<iframe className="stats-iframe" name="stat" src="https://zenitbet.sportstats.pro/soccer/?ref=54321"></iframe>
				</div> 
			)
	}
}
 


// WEBPACK FOOTER //
// ./src/routes/stats/index.js